import { Link } from "react-router-dom";

import { useBundle } from "../context/BundleContext";
import { CaseIdentity } from "../components/case/CaseIdentity";
import { GateStrip } from "../components/case/GateStrip";

export function CaseOverviewRoute() {
  const bundle = useBundle();
  const { overview } = bundle;

  return (
    <div className="mx-auto max-w-4xl px-6 py-12">
      <CaseIdentity overview={overview} />

      <section aria-labelledby="overview-gates-heading" className="mt-10">
        <h2 id="overview-gates-heading" className="font-editorial text-xl text-ink">
          Gate summary
        </h2>
        <div className="mt-4">
          <GateStrip gates={overview.gates} />
        </div>
      </section>

      <nav aria-label="Next steps" className="mt-10 flex flex-wrap gap-3">
        <Link
          to={`/cases/${overview.caseId}/replay`}
          className="rounded border border-rule-strong px-4 py-2 text-sm text-ink hover:bg-surface"
        >
          Open the differential replay →
        </Link>
        <Link
          to={`/cases/${overview.caseId}/receipt`}
          className="rounded border border-rule-strong px-4 py-2 text-sm text-ink hover:bg-surface"
        >
          Open the fix receipt →
        </Link>
      </nav>
    </div>
  );
}
